/**
 * Shared colour palette for all pixel art.
 *
 * Sprites are authored as arrays of single-character rows (see `Sprite` in
 * `sprites.ts`). Each character indexes this table. The values are an
 * original 16-bit-era inspired set chosen to sit well together at 16x16;
 * they are not taken from any commercial game's data.
 */

export const PALETTE: Record<string, string> = {
  '.': 'transparent',

  // Outlines / neutrals
  K: '#172f3c', // black outline
  A: '#708a94', // mid grey
  a: '#3c5663', // dark grey
  w: '#a9b8b2', // light grey
  W: '#fff3d8', // white

  // Reds
  R: '#be5861', // deep red
  r: '#ed9b7c', // salmon

  // Browns / skin
  N: '#9c694f', // brown
  D: '#684838', // dark brown
  S: '#ead0a1', // skin light
  s: '#b99470', // skin shadow

  // Oranges / yellows
  O: '#d59159', // orange
  Y: '#ffe2a1', // bright yellow
  y: '#e8b971', // gold

  // Greens
  M: '#245d61', // very dark green
  G: '#408a83', // green
  g: '#a1ccb3', // light green

  // Blues
  B: '#294459', // navy
  C: '#557b94', // blue
  c: '#9ec9d0', // light blue

  // Purples / pink
  P: '#e3bfdb', // pink
  p: '#b77eb6', // magenta
  V: '#736388', // violet

  // Misc
  T: '#85ded1', // cyan
  e: '#ebe5ce', // off-white
  x: '#15242d', // near-black (deep shadow)
}

/** Resolve a palette character to a CSS colour. */
export function colorOf(ch: string): string | null {
  const c = PALETTE[ch]
  if (c === undefined || c === 'transparent') return null
  return c
}
